import React, { useContext } from 'react'
import * as R from 'ramda'
import styled, { ThemeProvider } from 'styled-components'
import { AppContext } from '../../store'
import './style.scss'
import celular from '../../assets/images/celular.png'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  .container-section-control h1 {
    color: ${pickColor('default')};
  }
`

export default function SectionControl() {
  const { state } = useContext(AppContext)
  const { contentful } = state

  const { team: { fields = {} } = {} } = contentful || {}

  return (
    <ThemeProvider theme={fields}>
      <Container className='container-section-control'>
        <section className='content-container'>
          <div className='section-control-left'>
            <h1>Controle na palma da sua mão!</h1>
            <div className='description calibri'>
              Gerencie seu consumo e seus veículos cadastrados, além de realizar pagamentos, fazer recargas com
              facilidade e rapidez.
            </div>
          </div>
          <div className='container-image'>
            <img src={celular} alt='' className='celular' />
          </div>
        </section>
      </Container>
    </ThemeProvider>
  )
}
